<ng-container *ngIf="load">{{ errorMessage }}</ng-container>
<ng-content></ng-content>
